import dom from '../../../wrapper/DomWrapper';

import {
  ALT,
  HOST,
  GUID,
} from '../constants';

export default (imageURL) => `${HOST}?url=${dom.window.location.href}&guid=${GUID}&media=${imageURL}&description=${ALT}`;
